import { i18nFilter } from "app/filters/i18nFilter";

import { NoDataWrapper, NoDataIcon, NoDataText } from "../styles";

const translate = i18nFilter();

export const NoData = ({ text }: FixmeType) => {
    return (
        <NoDataWrapper>
            <NoDataIcon iconName="globe" />
            <NoDataText>{translate(text)}</NoDataText>
        </NoDataWrapper>
    );
};
